<template lang="pug">
	#app
		vuedal
		vue-progress-bar
		component(:is="layout")
</template>

<script>
import { Component as Vuedal } from "vuedals";
import { debounce } from "lodash";

export default {
	computed: {
		layout() {
			if (this.$route.meta.layout == "auth") {
				return "layout-auth";
			}
			return "layout-main";
		}
	},
	mounted() {
		/**
		 * Detect if the mouse or keyboard are inactive,
		 * If they are we fire the skip polling event to prevent extra requests when the webpage has not been closed.
		 * Once an event is triggered, send the false flag
		 */
		var timeoutInMiliseconds = 5 * 60 * 1000;
		var timeoutId;

		const startTimer = () => {
			timeoutId = window.setTimeout(doInactive, timeoutInMiliseconds);
		};

		const doInactive = () => {
			this.$bus.emit("window-inactive", true);
		};

		const resetTimer = () => {
			window.clearTimeout(timeoutId);
			this.$bus.emit("window-inactive", false);
			startTimer();
		};

		const setupTimers = () => {
			document.addEventListener(
				"mousemove",
				debounce(resetTimer, 5000, {
					leading: true,
					trailing: false
				}),
				false
			);
			document.addEventListener(
				"mousedown",
				debounce(resetTimer, 5000, {
					leading: true,
					trailing: false
				}),
				false
			);
			document.addEventListener(
				"keypress",
				debounce(resetTimer, 5000, {
					leading: true,
					trailing: false
				}),
				false
			);
			document.addEventListener(
				"touchmove",
				debounce(resetTimer, 5000, {
					leading: true,
					trailing: false
				}),
				false
			);
			startTimer();
		};

		setupTimers();
	},
	components: {
		Vuedal
	},
	name: "app"
};
</script>
